import recifeDisplayMediumItalic from './recife-display-medium-italic.otf';
import recifeDisplayRegular from './recife-display-regular.otf';

const recifeDisplaySrc = {
  400: {
    woff: undefined,
    woff2: undefined,
    ttf: undefined,
    otf: recifeDisplayRegular,
  },
  500: {
    woff: undefined,
    woff2: undefined,
    ttf: undefined,
    otf: recifeDisplayMediumItalic,
  },
  700: {
    woff: undefined,
    woff2: undefined,
    ttf: undefined,
    otf: recifeDisplayMediumItalic,
  },
};

export { recifeDisplaySrc };
